import { render, staticRenderFns } from "./artist.overview.vue?vue&type=template&id=2c989eb2&scoped=true"
import script from "./artist.overview.vue?vue&type=script&setup=true&lang=js"
export * from "./artist.overview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./artist.overview.vue?vue&type=style&index=0&id=2c989eb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c989eb2",
  null
  
)

export default component.exports